import { handleGetAvailability } from "../../../../redux/specialist-slices/auth.slice"
import { Box, Typography, Stack, Skeleton, Button, Alert } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import Icons from "../../../../assets/js/Icons"
import { useEffect, useState } from "react"
import Slot from "./slot"
import { Link } from "react-router-dom"

const daysOfWeek = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"]
function Availability() {
  const dispatch = useDispatch()
  const [data, setData] = useState({})
  const { loadings } = useSelector((s) => s.otherSlice)

  // --------------- Handle retrieve availability ---------------
  const retrieveSingle = async () => {
    const { availability } = await dispatch(
      handleGetAvailability()
    ).unwrap() || {}
    if (availability) {
      setData(availability)
    }
  }

  useEffect(() => {
    retrieveSingle()
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, mb: 3 }}>
        <Typography sx={{ fontSize: "24px", fontWeight: "600" }}>
          Chat availability
        </Typography>
        <Button
          size="small"
          color="primary"
          variant="contained"
          LinkComponent={Link}
          startIcon={<Icons.EditSolid />}
          to={`/specialist/profile/availability/update`}
        >Update
        </Button>
      </Box>

      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Weekly Schedule
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Select days and set your available hours
        </Typography>

        <Stack spacing={2} sx={{ maxWidth: 760 }}>
          {loadings?.retrieveSingle ?
            new Array(7).fill().map((_, i) => (
              <Skeleton key={i} sx={{ width: "100%", height: 80, transform: "none" }} />
            )) :
            !!Object.keys(data?.schedule || {}).length ?
              daysOfWeek.map((element, i) => (
                <Slot
                  key={i}
                  data={data}
                  day={element}
                />
              )) :
              <Alert color="error" severity="error">Chat availability not scheduled!</Alert>
          }
        </Stack>
      </Box>
    </>
  )
}

export default Availability